jQuery(document).ready(($) => {
  function addUtmParams() {
    const pageUrl = new URL(window.location.href);
    const params = ['utm_source', 'utm_medium', 'utm_id', 'utm_campaign', 'utm_content'];
    let utmParams = {};
    for (let i = 0; i < params.length; i++) {
      const param = params[i];
      const value = pageUrl.searchParams.get(param);
      if (value === null) {
        continue;
      }
      utmParams[param] = value;
    }

    const utmLinks = $('.onereach-utm-link');

    if (Object.keys(utmParams).length === 0 || utmLinks.length === 0) {
      return;
    }

    utmLinks.each(function () {
      let element = $(this);
      const anchor = element.find('a');
      if (anchor.length > 0) {
        element = anchor;
      }

      const href = element.attr('href');
      if (!href) {
        return;
      }

      // In-page anchors, and schemes like mailto:/tel:/javascript:, must not get params
      if (href.startsWith('#') || /^(?!https?:)[a-z][a-z0-9+.-]*:/i.test(href)) {
        return;
      }

      // A base is required so relative hrefs ('/contact/') parse instead of throwing
      let url;
      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }

      for (let param in utmParams) {
        if (utmParams[param]) {
          url.searchParams.set(param, utmParams[param]);
        }
      }

      // Keep the href in the shape it was authored in, so the host is not baked in
      const isAbsolute = /^[a-z][a-z0-9+.-]*:\/\//i.test(href);
      element.attr('href', isAbsolute ? url.toString() : url.pathname + url.search + url.hash);
    });
  }

  addUtmParams();
});